// frontend/src/components/layout/mobile/NotificationsButton.jsx
//
// The phone's bell: a dot while something needs the merchant's attention, and
// a sheet of the same cards the desktop bell drops down (NotificationList).

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ICON, Bell } from '../../../icons';
import { useNotifications } from '../../../contexts/NotificationContext';
import { NotificationList } from '../NotificationDropdown';
import BottomSheet from './BottomSheet';

export default function NotificationsButton() {
  const { t } = useTranslation();
  const { hasNotifications } = useNotifications();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const title = t('topMenu.notifications');

  return (
    <>
      <button
        type="button"
        className="mobile-top-bar__icon"
        aria-label={title}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <Bell size={ICON.xxl} />
        {hasNotifications && <span className="mobile-top-bar__dot" />}
      </button>
      <BottomSheet open={open} onClose={close} label={title}>
        <section className="sheet-section mobile-notifications">
          <h2 className="sheet-section__title">{title}</h2>
          <NotificationList onDone={close} />
        </section>
      </BottomSheet>
    </>
  );
}
